import { DragDropModule } from '@angular/cdk/drag-drop';
import { OverlayModule } from '@angular/cdk/overlay';
import { NgModule } from '@angular/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatChipsModule } from '@angular/material/chips';
import { MAT_DATE_FORMATS, MAT_DATE_LOCALE, MAT_RIPPLE_GLOBAL_OPTIONS } from '@angular/material/core';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MAT_TABS_CONFIG } from '@angular/material/tabs';
import { MomentDateModule } from '@angular/material-moment-adapter';

import {
  TIIME_DATE_FORMATS,
  TIIME_RIPPLE_GLOBAL_OPTIONS,
  TiimeButtonModule,
  TiimeCheckboxModule,
  TiimeDatepickerModule,
  TiimeDialogModule,
  TiimeIconModule,
  TiimeInputContainerModule,
  TiimeLoaderModule,
  TiimeMenuModule,
  TiimeOverlayModule,
  TiimePaginatorModule,
  TiimeProgressBarModule,
  TiimeRadioModule,
  TiimeSlideToggleModule,
  TiimeSnackbarModule,
  TiimeTooltipModule
} from 'tiime-components';

@NgModule({
  imports: [MomentDateModule],
  providers: [
    {
      provide: MAT_RIPPLE_GLOBAL_OPTIONS,
      useValue: TIIME_RIPPLE_GLOBAL_OPTIONS
    },
    { provide: MAT_DATE_FORMATS, useValue: TIIME_DATE_FORMATS },
    { provide: MAT_DATE_LOCALE, useValue: 'fr-FR' },
    { provide: MAT_TABS_CONFIG, useValue: { animationDuration: '0ms' } }
  ],
  exports: [
    TiimeSlideToggleModule,
    TiimeCheckboxModule,
    TiimeMenuModule,
    TiimeRadioModule,
    TiimeButtonModule,
    TiimePaginatorModule,
    TiimeIconModule,
    TiimeSnackbarModule,
    TiimeTooltipModule,
    TiimeDialogModule,
    TiimeInputContainerModule,
    TiimeDatepickerModule,
    TiimeProgressBarModule,
    TiimeLoaderModule,
    MatButtonToggleModule,
    MatInputModule,
    MatAutocompleteModule,
    MatProgressSpinnerModule,
    MatChipsModule,
    MatSelectModule,
    TiimeOverlayModule,
    OverlayModule,
    DragDropModule
  ]
})
export class MaterialModule {}
